import Link from 'next/link';
import { useRouter } from 'next/router';

import { getCrawlerFiltersLinkHref } from 'search/utils/getCrawlerFiltersLinkHref';
import { IConstructorFacetMultiple } from 'shared/types/ConstructorFacet';
import { UnorderedList } from 'shared/components/UnorderedList';

export interface ISearchFilterBrandCrawler {
  facet: IConstructorFacetMultiple;
  name: string;
}
export const SearchFilterBrandCrawler = ({ facet, name }: ISearchFilterBrandCrawler) => {
  const { pathname, query } = useRouter();

  return (
    <UnorderedList data-qa="search_filter_list">
      {facet.options?.map((option) => {
        return (
          <li key={option.value}>
            <Link
              href={getCrawlerFiltersLinkHref({ pathname, query, option, facetType: name })}
              key={option.display_name}
              passHref
              prefetch={false}
              scroll
              shallow
              legacyBehavior
            >
              {option.display_name}
            </Link>
          </li>
        );
      })}
    </UnorderedList>
  );
};
